import { useLocation } from "react-router-dom";

export const useQueryParam = (query: string): string | undefined => {
	const search = useLocation().search;

	if (query) {
		const result = new URLSearchParams(search).get(query);

		if (result) {
			return result;
		}
	}

	return undefined;
};

export const useQueryParamHide = (options?: {
	overrideForSpecificPages: boolean;
}) => {
	const queryHide = useQueryParam("hide");
	const page = window?.location?.hash;

	if (options?.overrideForSpecificPages && page === "#/dashboard") {
		return true;
	}

	if (queryHide) {
		return Boolean(parseInt(queryHide));
	}

	return false;
};
